import React, { useEffect } from "react";
import { useIntl, defineMessages } from "react-intl";
import { Button } from "@natera/form";
import "./upsCreatePaymentFailure.scss";
import PaymentFailureIcon from "@app/preBill/assets/svg/payment-failure.svg";
import Svg from "@natera/material/lib/svg";
import { useNavigate } from "react-router-dom";
import { routes } from "@app/routing";
import BillingContactUs from "@app/postBill/components/billingContactUs";
import { useUPSHeapEvent } from "@app/ups/hooks";
import { HEAP_EVENTS } from "@app/provider/types";

const messages = defineMessages({
  upsCreatePaymentFailureTitle: {
    id: "upsCreatePaymentFailureTitle",
    defaultMessage:
      "Your payment couldn’t be completed. Please check your information or try a different payment method.",
  },
  upsCreatePaymentFailureGoBackButton: {
    id: "upsCreatePaymentFailureGoBackButton",
    defaultMessage: "Go back",
  },
});

const UPSCreatePaymentFailure: React.FC = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { trackUPSHeapEvent } = useUPSHeapEvent();

  useEffect(() => {
    trackUPSHeapEvent({
      eventKey: HEAP_EVENTS.ups_billing_payment_failedpayment,
    });
  }, []);

  const handleGoBackButton = () => {
    navigate(routes.upsCreatePaymentMethod);
  };

  return (
    <div className="ups-create-payment-failure">
      <div className="ups-create-payment-failure__content">
        <div className="ups-create-payment-failure__icon">
          <Svg content={PaymentFailureIcon} />
        </div>
        <div className="ups-create-payment-failure__description">
          <div className="ups-create-payment-failure__title">
            {intl.formatMessage(messages.upsCreatePaymentFailureTitle)}
          </div>
          <BillingContactUs />
        </div>
        <Button
          unelevated
          onClick={handleGoBackButton}
          className="ups-create-payment-failure__button"
        >
          {intl.formatMessage(messages.upsCreatePaymentFailureGoBackButton)}
        </Button>
      </div>
    </div>
  );
};

export default UPSCreatePaymentFailure;
